import { CapoPlugin } from "/builds/1tool/damage-report/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];